import React from 'react';
import CopyButton from './CopyButton';

/** One official contract address with a chain tag, explorer link and copy button. */
const ContractRow = ({ chain, showExplorer = false }) => (
  <div className="flex min-w-0 items-center gap-2 rounded-2xl border-[3px] border-ink bg-paper px-3 py-2.5 shadow-hard lg:gap-3 lg:px-4 lg:py-3">
    <span className="shrink-0 rounded-lg bg-ink px-2 py-[3px] text-[11px] font-bold tracking-[0.5px] text-sun">{chain.short}</span>
    <code className="min-w-0 flex-1 break-all font-mono text-[12px] leading-snug sm:text-[13px]" title={`${chain.name} contract`}>
      {chain.address}
    </code>
    {showExplorer && (
      <a
        href={chain.explorer}
        target="_blank"
        rel="noopener noreferrer"
        className="hidden shrink-0 text-[13px] font-semibold underline sm:inline"
        aria-label={`View on ${chain.explorerName}`}
      >
        {chain.explorerName} ↗
      </a>
    )}
    <CopyButton value={chain.address} />
  </div>
);

export default ContractRow;
